import { Component, OnInit, OnDestroy } from '@angular/core';
import {CordovaService} from "../shared/services/cordova/cordova.service";
import {environment} from "../../environments/environment";
import {INAPPBROWSER_CLOSE_BUTTON_CAPTION, INAPPBROWSER_TOOLBAR_COLOR} from '../shared/defines/client.const';

const INTERVAL_TIME: number = 2000; // 인터벌 시간 상수

@Component({
  selector: 'app-donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.scss']
})
export class DonationComponent implements OnInit, OnDestroy {
  public dynamicPrefix: string = 'm';
  private prefixInterval: any;

  public get showKakaoPay(): boolean {
    return !this.cordovaService.isIOS;
  }

  constructor(
    private cordovaService: CordovaService,
  ) { }

  ngOnInit(): void {
    this.prefixInterval = setInterval(() => {
      this.dynamicPrefix = this.dynamicPrefix === 'm' ? 'www' : 'm';
    }, INTERVAL_TIME);
  }

  ngOnDestroy(): void {
    if (this.prefixInterval) {
      clearInterval(this.prefixInterval);
    }
  }

  onClicKakao(event) {
    if (this.cordovaService.cordova) {
      const options = [
        'location=no',
        'fullscreen=yes',
        'toolbartranslucent=no',
        `toolbarcolor=${INAPPBROWSER_TOOLBAR_COLOR}`,
        `closebuttoncaption=${INAPPBROWSER_CLOSE_BUTTON_CAPTION}`,
        'hardwareback=yes',
        'hidenavigationbuttons=yes',
      ].join(',');

      this.cordovaService.cordova.InAppBrowser.open(environment.donationUrl, '_system', options);
    }
    else {
      window.open(environment.donationUrl, '_blank');
    }
  }

  onClickWeb(event) {
    // TODO: 웹 페이지로 이동
  }

}
